import { render } from "./MyWorks.vue?vue&type=template&id=491c7c09&scoped=true"
import script from "./MyWorks.vue?vue&type=script&lang=js"
export * from "./MyWorks.vue?vue&type=script&lang=js"

import "./MyWorks.vue?vue&type=style&index=0&id=491c7c09&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491c7c09"]])

export default __exports__